import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import TruncatedText from "shiitake";
import { UitkFigure, UitkImage } from "uitk-react-images";
import { UitkText, UitkHeading } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkCardAlohaContentSection, UitkCardAlohaLink, UitkCardAloha } from "uitk-react-cards";
import { getAuthorFromCityStayedAtHotelText, getPostedAgoText } from "../../hotelRecentReviewsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import {
  HotelRecentReviewsFlexModuleResult,
  HotelReview,
} from "typings/microserviceModels/hotel-recent-reviews-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const ThumbnailImageLeftCard = (props: { model: HotelRecentReviewsFlexModuleResult; hotel: HotelReview }) => {
  const { model, hotel } = props;
  const { subheadingForThumbnailImageLeftCardView, brandName } = model;
  const {
    hotelName,
    hotelImageUrl,
    hotelInfositeUrl,
    date: reviewPostedDate,
    rating,
    reviewTitle,
    reviewText,
    authorName,
    authorLocation,
  } = hotel;

  const { formatText } = useLocalization();

  const reviewTitleToDisplay = () => {
    const title =
      subheadingForThumbnailImageLeftCardView === "brandVerifiedReview"
        ? formatText("hotelRecentReviews.verifiedBrandReview", brandName)
        : reviewTitle;

    return (
      <UitkSpacing margin={{ blockend: "two" }}>
        <UitkText className="uitk-type-heading-400">{title}</UitkText>
      </UitkSpacing>
    );
  };

  return (
    <UitkCardAloha tag="li">
      <UitkCardAlohaContentSection>
        <UitkLayoutFlex>
          <UitkLayoutFlexItem minWidth="third_width" shrink={0}>
            <div>
              <UitkFigure className="all-image-fit-cover uitk-card-roundcorner-all" ratio={UitkFigure.AspectRatio.R4_3}>
                <UitkImage src={hotelImageUrl} alt={hotelName} placeholderImage={true} />
              </UitkFigure>
            </div>
          </UitkLayoutFlexItem>
          <UitkLayoutFlexItem grow={1}>
            <UitkSpacing margin={{ inlinestart: "three" }}>
              <UitkLayoutFlex direction="column" justifyContent="space-between">
                <UitkHeading level={3} size={500} overflow="truncate" className="truncate-lines-2">
                  {hotelName}
                </UitkHeading>
                <UitkLayoutFlex direction="column">
                  <UitkText size={300}>{formatText("hotelRecentReviews.ratingOutOf5", rating)}</UitkText>
                  <UitkText size={200}>{getPostedAgoText(reviewPostedDate)}</UitkText>
                </UitkLayoutFlex>
              </UitkLayoutFlex>
            </UitkSpacing>
          </UitkLayoutFlexItem>
        </UitkLayoutFlex>
      </UitkCardAlohaContentSection>
      <UitkCardAlohaContentSection border="top">
        {reviewTitleToDisplay()}
        <TruncatedText
          lines={2}
          renderFullOnServer={true}
          overflowNode={"\u2026\u0022"}
          className="uitk-type-paragraph-300 all-b-margin-two"
        >
          {`\u0022${reviewText}\u0022`}
        </TruncatedText>
        <UitkText size={200} className="truncate-lines-2">
          {getAuthorFromCityStayedAtHotelText(authorName, authorLocation, hotelName)}
        </UitkText>
      </UitkCardAlohaContentSection>
      <UitkCardAlohaLink>
        <TrackedLink
          moduleName="hotelRecentReviews"
          rfrr="hotelInfositeLink"
          href={hotelInfositeUrl}
          data-testid={`hotel-recent-reviews-thumbnail-image-left-card-${hotelName}`}
        >
          {hotelName}
        </TrackedLink>
      </UitkCardAlohaLink>
    </UitkCardAloha>
  );
};

export default ThumbnailImageLeftCard;
